module.exports = __webpack_public_path__ + "static/media/trash.82f1b030.svg";